interface AvatarProps {
  src?: string | undefined;
  alt: string;
  size?: number;
}

const safeImageSource = (source: string | undefined): string | undefined => {
  if (!source || source.length > 2_048) return undefined;
  const sameOriginPrefix = `${window.location.origin}/`;
  if (!source.startsWith(sameOriginPrefix)) return undefined;
  try {
    const url = new URL(source);
    return ['http:', 'https:'].includes(url.protocol) &&
      url.origin === window.location.origin &&
      !url.username &&
      !url.password
      ? url.toString()
      : undefined;
  } catch {
    return undefined;
  }
};

const Avatar = ({ src, alt, size = 40 }: AvatarProps) => {
  const safeSource = safeImageSource(src);
  const sizeClass = [36, 40, 72].includes(size) ? `avatar-${size}` : 'avatar-40';
  if (!safeSource) {
    return (
      <span className={`avatar avatar-fallback ${sizeClass}`} aria-label={alt} role="img">
        {alt.trim().slice(0, 1).toLocaleUpperCase() || '?'}
      </span>
    );
  }
  return (
    <img
      src={safeSource}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      referrerPolicy="no-referrer"
      className={`avatar ${sizeClass}`}
    />
  );
};

export default Avatar;
